<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form #form [form]="formInput">
        </sm-form>
        <p-button class="mt-2" icon="fas fa-run" label="Starten" (onClick)="run()"></p-button>
    </p-panel>
    <div class="flex-item-fill flex-col">
        <sm-toolbar *ngIf="data?.length > 0">
            <p-checkbox class="mr-3" label="Eine Spalte pro Konfiguration" name="oneColumnPerConfig" [(ngModel)]="oneColumnPerConfig" [binary]="true" (ngModelChange)="setOneColumnPerConfig()"></p-checkbox>
            <p-checkbox class="mr-3" label="Eine Zeile pro Konfiguration" name="oneRowPerConfig" [(ngModel)]="oneRowPerConfig" [binary]="true" (ngModelChange)="setOneRowPerConfig()"></p-checkbox>
            <p-checkbox class="mr-3" label="Nur ausgewählte Konfigurationen" *ngIf="oneRowPerConfig" name="onlySelectedConfigs" [(ngModel)]="onlySelectedConfigs" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox class="mr-3" label="Nur mit bearbeiteten Objekten" name="onlyWithWork" [(ngModel)]="onlyWithWork" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
            <p-checkbox label="Nur mit Fehler-Objekten" name="onlyWithError" [(ngModel)]="onlyWithError" [binary]="true" (ngModelChange)="updateTable()"></p-checkbox>
        </sm-toolbar>
        <sm-table2 *ngIf="tableData != null" [data]="tableData" class="flex-item-fill height100p"></sm-table2>
    </div>
</div>
